let accessToken: string | null = null;
let currentTenantId: string | null = null;

export function setAccessToken(token: string | null) {
  accessToken = token;
}

export function getAccessToken() {
  return accessToken;
}

export function setTenantId(tenantId: string | null) {
  currentTenantId = tenantId;
}

export function getTenantId() {
  return currentTenantId;
}
